import { Observable, map } from 'rxjs';

import { FeelSubscriptionApiRepository } from '@features/feel/infrastructure/api/feel-subscription.api.repository';
import { NewsletterFeaturePublicApi } from '@features/newsletter/public.api';

export const feelJoinUseCase$ = (
    { storeId, languageId },
    feelSubscriptionApiRepository: FeelSubscriptionApiRepository
): Observable<void> =>
    feelSubscriptionApiRepository.signUp(storeId, languageId).pipe(map(() => null));

export const feelJoinNewsletterUseCase$ = (
    storeAndLanguage,
    newsletterPublicApi: NewsletterFeaturePublicApi,
    newsletterSections: string[],
    email: string
): Observable<void> =>
    newsletterPublicApi.subscribeToNewsletter$(
        {
            address: { email },
            newsletters: newsletterSections.length
                ? newsletterSections
                : [],
            privacyPolicyAccepted: true,
        },
        storeAndLanguage
    ).pipe(map(() => null));
